/** "error" loading state */
export default 4;
